// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"730":"0a16583d","787":"cce4dfc7"}[chunkId] + ".chunk.js";
};